var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SvgComponent",
    {
      attrs: {
        fill: "currentColor",
        width: "16",
        height: "17",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 17",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M11.9997 6.06543C11.9997 6.80181 11.4027 7.39876 10.6663 7.39876C9.92996 7.39876 9.33301 6.80181 9.33301 6.06543C9.33301 5.32905 9.92996 4.7321 10.6663 4.7321C11.4027 4.7321 11.9997 5.32905 11.9997 6.06543Z",
          fill: "currentColor",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8.03793 1.56543H7.96142C6.4225 1.56542 5.21647 1.56542 4.27548 1.69193C3.31232 1.82142 2.55231 2.09165 1.95577 2.68819C1.35923 3.28473 1.089 4.04474 0.959506 5.0079C0.832993 5.94889 0.833 7.15491 0.833008 8.69383V8.77035C0.833 10.3093 0.832993 11.5153 0.959506 12.4563C1.089 13.4195 1.35923 14.1795 1.95577 14.776C2.55231 15.3725 3.31232 15.6428 4.27548 15.7723C5.21647 15.8988 6.4225 15.8988 7.96143 15.8988H8.03792C9.57685 15.8988 10.7829 15.8988 11.7239 15.7723C12.687 15.6428 13.447 15.3725 14.0436 14.776C14.6401 14.1795 14.9103 13.4195 15.0398 12.4563C15.1664 11.5153 15.1663 10.3093 15.1663 8.77034V8.69385C15.1663 7.15492 15.1664 5.94889 15.0398 5.0079C14.9103 4.04474 14.6401 3.28473 14.0436 2.68819C13.447 2.09165 12.687 1.82142 11.7239 1.69193C10.7829 1.56542 9.57685 1.56542 8.03793 1.56543ZM2.66287 3.39529C3.04264 3.01552 3.55646 2.79759 4.40873 2.68301C5.27538 2.56649 6.41419 2.56543 7.99967 2.56543C9.58516 2.56543 10.724 2.56649 11.5906 2.68301C12.4429 2.79759 12.9567 3.01552 13.3365 3.39529C13.7162 3.77506 13.9342 4.28888 14.0488 5.14115C14.1653 6.0078 14.1663 7.14661 14.1663 8.7321C14.1663 9.03225 14.1663 9.31639 14.1655 9.58571L14.0174 9.56521C12.1216 9.30271 10.3867 10.2883 9.50325 11.7738C8.3636 8.89051 5.35197 6.92414 1.98683 7.40734L1.83632 7.42904C1.84389 6.49204 1.86879 5.74953 1.95059 5.14115C2.06517 4.28888 2.2831 3.77506 2.66287 3.39529Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }